import React from 'react';
import { logger } from '../utils/logger';
import { reportFaroError } from '../observability';

/**
 * Root-level Error Boundary to catch render errors and show a fallback UI
 * instead of a blank screen. Ready for integration with error reporting (e.g. Sentry).
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        logger.error('ErrorBoundary caught an error:', error, errorInfo);
        try {
            if (error instanceof Error) {
                reportFaroError(error, {
                    componentStack: errorInfo?.componentStack?.slice(0, 200)
                });
            }
        } catch (_) {
            // observability not available or not enabled
        }
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoToLogin = () => {
        window.location.replace('/login');
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '2rem',
                    maxWidth: '500px',
                    margin: '2rem auto',
                    fontFamily: 'Arial, sans-serif',
                    textAlign: 'center'
                }}>
                    <h1 style={{ color: '#333', marginBottom: '1rem' }}>Something went wrong</h1>
                    <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                        An unexpected error occurred. Please try again or contact support if the problem persists.
                    </p>
                    <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button
                            type="button"
                            onClick={this.handleReload}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: '#0066cc',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Reload page
                        </button>
                        <button
                            type="button"
                            onClick={this.handleGoToLogin}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: '#6c757d',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Go to login
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
